import * as React from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const StackedAreaChartComponent = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={600}>
      <AreaChart
        data={data}
        margin={{
          top: 10, right: 30, left: 0, bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis scale="sqrt" />
        <Tooltip />
        <Legend />
        <Area type="monotone" dataKey="creates" stroke="#04c44e" fill="#8cfab6" />
        <Area type="monotone" dataKey="reads" stroke="#e6e212" fill="#fcfb9f" />
        <Area type="monotone" dataKey="updates" stroke="#443dd9" fill="#7a87fa" />
        <Area type="monotone" dataKey="deletes" stroke="#f7b934" fill="#fad37f" />
        <Area type="monotone" dataKey="alerts" stroke="#de3309" fill="#fa6150" />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default StackedAreaChartComponent;
